var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.minuteString))]),_c('span',{staticStyle:{"margin-left":"1px","margin-right":"1px"}},[_vm._v(":")]),_c('span',[_vm._v(_vm._s(_vm.secondString))])])
}
var staticRenderFns = []

export { render, staticRenderFns }